let cachedFormUrl: string | null = null;
let cachedFormName: string | null = null;

export async function getFormUrl(formName: string): Promise<string> {
  if (cachedFormUrl && cachedFormName === formName) {
    return cachedFormUrl;
  }
  
  return new Promise((resolve, reject) => {
    const handler = (event: MessageEvent) => {
      if (event.data && event.data.type === 'FORM_URL_RESPONSE' && event.data.name === formName) {
        window.removeEventListener('message', handler);
        if (event.data.submitAddr) {
          cachedFormUrl = event.data.submitAddr;
          cachedFormName = formName;
          resolve(event.data.submitAddr);
        } else {
          reject(new Error('No submit address returned'));
        }
      }
    };
    
    window.addEventListener('message', handler);
    
    window.parent.postMessage({
      type: 'GET_FORM_URL',
      name: formName,
    }, '*');
    
    setTimeout(() => {
      window.removeEventListener('message', handler);
      resolve('https://form.readdy.ai/submit');
    }, 3000);
  });
}